<template>
  <div class="my-container">
    <el-drawer :visible.sync="view.sift.show" direction="btt" :show-close="true" custom-class="sift opts">
      <div class="main">
        <el-row v-if="config.type === 'post'" style="padding: 0 20px;">
          <el-col v-for="item in catalogs" :key="item.id" :span="6" class="align-center" style="height:40px;">
            <el-button :class="{ 'on': sift.catalogid === item.id }" @click="select(item.id, item.label)">
              {{ getName(item.id, item.label) }}
            </el-button>
          </el-col>
        </el-row>
        <!-- <el-row v-if="config.type === 'aiart'">
          <el-col :span="4" class="title">{{ $t('i.style') }}</el-col>
          <el-col :span="20">
            <el-button :class="{ 'on': sift.styleid === '0' }" @click="selectStyle('0', $t('i.all'))">
              {{ $t('i.all') }}
            </el-button>
            <el-button v-for="item in styles" :key="item[0]" :class="{ 'on': sift.styleid === item[0] }" @click="selectStyle(...item)">
              {{ item[1] }}
            </el-button>
          </el-col>
        </el-row> -->
        <el-row v-if="config.type === 'aiart'">
          <el-col :span="4" class="title">{{ $t('i.sift') }}</el-col>
          <el-col :span="20">
            <el-button v-for="(type, idx) in originTypes" :key="idx" :name="type[0]" :class="{ 'on': sift.origin === type[0] }" @click="selectOrigin(type[0], type[1])">
              {{ type[1] }}
            </el-button>
          </el-col>
        </el-row>
        <el-row v-if="config.type !== 'post' && config.type !== 'aiart'">
          <el-col :span="4" class="title">{{ catalogRowTitle }}</el-col>
          <el-col :span="20">
            <el-button v-for="item in displayCatalogs" :key="item.id" :class="{ 'on': sift.catalogid == item.id }" @click="select(item.id, item.label)">
              {{ getName(item.id, item.label) }}
            </el-button>
            <el-button v-if="inSubCatalogView" class="back" @click="selectBack()">
              {{ $t('i.back') }}
            </el-button>
          </el-col>
        </el-row>
        <el-row v-if="config.type === 'works'">
          <el-col :span="4" class="title">{{ $t('i.classify') }}</el-col>
          <el-col :span="20">
            <el-button v-for="(workClass, idx) in workClasses" :key="idx" :name="workClass.classid" :class="{ 'on': sift.classid === workClass.classid }" @click="selectClass(workClass.classid, workClass.label)">
              {{ workClass.label }}
            </el-button>
          </el-col>
        </el-row>
        <el-row v-if="config.type !== 'post' && config.type !== 'aiart'">
          <el-col :span="4" class="title">{{ $t('i.sift') }}</el-col>
          <el-col :span="20">
            <el-button v-for="(type, idx) in types" :key="idx" :name="type[0]" :class="{ 'on': sift.type === type[0] }" @click="selectType(idx, type[0])">
              {{ type[1] }}
            </el-button>
          </el-col>
        </el-row>
        <el-row v-if="config.type !== 'works' && config.type !== 'album' && config.type !== 'post' && config.type !== 'aiart'">
          <el-col :span="4" class="title">{{ $t('i.sort') }}</el-col>
          <el-col :span="20">
            <!-- <el-button v-for="(type, idx) in sortTypes" :key="idx" :name="type[0]" :class="{ 'on': sift.sortType === type[0] }" @click="sift.sortType = type[0]">
              {{ type[1] }}
            </el-button> -->
            <el-button v-for="(type, idx) in sorts" :key="idx" :name="type[0]" :class="{ 'on': sift.sort === type[0] }" @click="sift.sort = type[0]">
              {{ type[1] }}
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="btn-opts">
        <el-button class="btn-cancel" @click="view.sift.show = false">
          {{ $t('i.cancel') }}
        </el-button>
        <el-button type="light" class="btn-ok" @click="submit()">
          {{ $t('i.ok') }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import conf from '@/js/conf/conf'
import { mixins } from '@/mixins/common'
export default {
  components: {},
  mixins: [mixins],
  data() {
    const data = {}
    data.sift = {
      type: 'new',
      typeid: '0',
      classid: '0',
      catalogid: '0',
      catalogName: '',
      styleid: '0',
      styleName: '',
      sort: 'desc',
      sortType: 'update',
      origin: '0',
      originName: ''
    }
    return data
  },
  computed: {
    sorts() {
      return [['desc', this.$t('i.reverse')], ['asc', this.$t('i.positive')]]
    },
    config() {
      return this.view.sift
    },
    viewConfig() {
      return this.view[this.config.type] || {}
    },
    types() {
      return this.viewConfig.types ? this.viewConfig.types() : ''
    },
    sortTypes() {
      return this.viewConfig.sortTypes ? this.viewConfig.sortTypes() : ''
    },
    originTypes() {
      return this.viewConfig.originTypes ? this.viewConfig.originTypes() : ''
    },
    workClasses() {
      return conf.workClasses()
    },
    catalogs() {
      if (this.config.type === 'works' || this.config.type === 'album') {
        return conf.catalogs()
      } else if (this.config.type === 'zone' || this.config.type === 'post') {
        return conf.categories()
      } else {
        return {}
      }
    },
    subCatalogParent() {
      if (this.config.type !== 'works' && this.config.type !== 'album') return null
      const id = this.sift.catalogid
      const list = conf.catalogs()
      const parent = list.find(c => c.id === id && c.sub)
      if (parent) return parent
      for (const c of list) {
        if (c.sub && c.sub.some(s => s.id === id)) return c
      }
      return null
    },
    inSubCatalogView() {
      return !!this.subCatalogParent
    },
    catalogRowTitle() {
      if (this.inSubCatalogView) {
        return this.subCatalogParent.label
      }
      return this.$t('i.catalog')
    },
    displayCatalogs() {
      if (this.inSubCatalogView) {
        return this.subCatalogParent.sub
      }
      return this.catalogs
    }
  },
  watch: {
    'view.sift.show': {
      handler() {
        if (this.config.show && this.config.type) {
          this.sift.type = this.viewConfig.type
          this.sift.typeid = this.viewConfig.typeid
          this.sift.classid = this.viewConfig.classid
          this.sift.sort = this.viewConfig.sort
          this.sift.sortType = this.viewConfig.sortType
          this.sift.origin = this.viewConfig.origin
          if (this.config.type === 'aiart') {
            this.sift.originName = this.viewConfig.originName
          } else {
            this.sift.catalogid = this.viewConfig.catalogid
            this.sift.catalogName = this.viewConfig.catalogName
          }
        }
      }
    }
  },
  methods: {
    getName(id, name) {
      return id === 0 ? (this.config.type === 'post' ? this.$t('i.default') : this.$t('i.all')) : name
    },
    selectType(typeid, type) {
      this.sift.typeid = typeid
      this.sift.type = type
    },
    select(id, name) {
      this.sift.catalogid = id
      this.sift.catalogName = this.getName(id, name)
    },
    selectBack() {
      this.sift.catalogid = 0
      this.sift.catalogName = this.getName(0, '')
    },
    selectOrigin(id, name) {
      this.sift.origin = id
      this.sift.originName = name
    },
    selectClass(id, name) {
      this.sift.classid = id
    },
    // selectStyle(id, name) {
    //   this.sift.styleid = id
    //   this.sift.styleName = this.getName(id, name)
    // },
    submit() {
      this.viewConfig.type = this.sift.type
      this.viewConfig.typeid = this.sift.typeid
      this.viewConfig.sort = this.sift.sort
      this.viewConfig.sortType = this.sift.sortType
      this.viewConfig.origin = this.sift.origin
      this.viewConfig.classid = this.sift.classid
      if (this.config.type === 'aiart') {
        this.viewConfig.originName = this.sift.originName
      } else {
        this.viewConfig.catalogid = this.sift.catalogid
        this.viewConfig.catalogName = this.sift.catalogName
      }
      this.view.sift.show = false
    }
  }
}
</script>
